import { DurationInfoResponseBuilder } from './DurationInfoResponseBuilder';
import { SupplierInfoResponseBuilder } from './SupplierInfoResponseBuilder';
import { BookingQuestionResponseBuilder } from './BookingQuestionResponseBuilder';
import { LanguageGuideResponseBuilder } from './LanguageGuideResponseBuilder';
import { IBaseArgument } from './IBaseArgument';
import { BaseResponseBuilder } from './BaseResponseBuilder';

export class OfferDetailResponseBuilder extends BaseResponseBuilder {
    constructor() {
        super('OfferDetail');
    }
    public withActivityId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['activityId'] = this.initField(null, args);
        return this;
    }

    public withOfferDetailRef = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['offerDetailRef'] = this.initField(null, args);
        return this;
    }

    public withActivityOfferId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['activityOfferId'] = this.initField(null, args);
        return this;
    }

    public withTitle = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['title'] = this.initField(null, args);
        return this;
    }

    public withDescription = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['description'] = this.initField(null, args);
        return this;
    }

    public withDurationSummary = (builder: DurationInfoResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['durationSummary'] = this.initField(builder, args);
        return this;
    }

    public withInclusionRefId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['inclusionRefId'] = this.initField(null, args);
        return this;
    }

    public withExclusionRefId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['exclusionRefId'] = this.initField(null, args);
        return this;
    }

    public withBookingRequirementRefId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['bookingRequirementRefId'] = this.initField(null, args);
        return this;
    }

    public withLogisticRefId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['logisticRefId'] = this.initField(null, args);
        return this;
    }

    public withItineraryRefId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['itineraryRefId'] = this.initField(null, args);
        return this;
    }

    public withSupplierInfo = (builder: SupplierInfoResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['supplierInfo'] = this.initField(builder, args);
        return this;
    }

    public withBookingQuestion = (builder: BookingQuestionResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['bookingQuestion'] = this.initField(builder, args);
        return this;
    }

    public withLanguageGuides = (builder: LanguageGuideResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['languageGuides'] = this.initField(builder, args);
        return this;
    }

    public withEnrichedBookingQuestions = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['enrichedBookingQuestions'] = this.initField(null, args);
        return this;
    }
}
